"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _lodash = _interopRequireDefault(require("lodash"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var icons = _interopRequireWildcard(require("../../toolkit/icons"));

var _localization = require("../../toolkit/localization");

var _providers = require("../../toolkit/providers");

var _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EditButton = (0, _mobxReact.observer)(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(EditButton, _Component);

  var _super = _createSuper(EditButton);

  function EditButton() {
    var _this;

    (0, _classCallCheck2["default"])(this, EditButton);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(EditButton, [{
    key: "render",
    value: function render() {
      var children = this.props.children;

      var _LocalizationStore = new _localization.LocalizationStore(this.context),
          i18n = _LocalizationStore.i18n;

      return /*#__PURE__*/_react["default"].createElement(_IconButton["default"], (0, _extends2["default"])({
        popoverContent: i18n("Edit")
      }, this.props, {
        icon: icons.edit
      }), children);
    }
  }]);
  return EditButton;
}(_react.Component), _class2.contextType = _providers.LegoContext, _class2.propDoc = _lodash["default"].omit(_IconButton["default"].propDoc, ["icon"]), _class2.demoProps = {
  onClick: function onClick() {}
}, _class2.discussion = "\n    This component wraps [`IconButton`](/lego/component/IconButton).\n  ", _temp)) || _class;

var _default = EditButton;
exports["default"] = _default;